import { filter, find, findIndex } from 'lodash';
import { observable, action, makeObservable } from 'mobx'
import ITheme from '../interfaces/ITheme';

export default class ThemeStore {

     list: ITheme[] = [];

    
    addRecords(records: ITheme[]): any {
        if (records.length > 0) {
            records.forEach((record: ITheme) => this.addRecord(record));
        }
    }

    
    private addRecord(record: ITheme) {
        if (!record) {
            return;
        }

        const index = findIndex(this.list, { id: record.id });
        if (index >= 0) {
            this.list.splice.apply(this.list, [index, 1, record]);
        } else {
            this.list.push(record);
        }
    }

    public getById(id: string): ITheme {
        return find(this.list, { id: id });
    }

    public getByIds(ids: string[]): ITheme[] {
        return filter(this.list, item => {
            if (ids.includes(item.id)) {
                return true;
            }
            return false;
        })
    }

    public getByUserId(userId: string): ITheme[] {
        return filter(this.list, { userId: userId });
    }

    public removeById(id: string) {
        this.list = filter(this.list, item => {
            if (item.id != id) {
                return true;
            }
            return false;
        })
    }

    constructor() {
        makeObservable(this, {
            list: observable,
            addRecords: action,
            removeById: action,
        })
    }
}